import { actions } from 'src/constants';

export default {
  setTooltipVisibility: (tooltipId, show) => ({
    type: actions.SET_TOOLTIP_VISIBILITY,
    payload: { tooltipId, show },
  }),
};
